import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { InfinityDataGridAction } from './infinityDataGrid.action';
import { infinityDataGridInitialState } from './infinityDataGrid.constant';

export const infinityDataGridReducer = reducerWithInitialState(infinityDataGridInitialState)
  .case(InfinityDataGridAction.refreshData, (state) => {
    const refreshToken = (state.refreshToken ?? 0) + 1;

    return {
      ...state,
      refreshToken,
    };
  })
  .case(InfinityDataGridAction.updateRowCount, (state, rowCount) => {
    return {
      ...state,
      rowCount,
    };
  })
  .case(InfinityDataGridAction.updateSortModel, (state, sortModel) => {
    return {
      ...state,
      sortModel,
    };
  })
  .case(InfinityDataGridAction.updateSearch, (state, search) => {
    return {
      ...state,
      search,
    };
  })
  .case(InfinityDataGridAction.destroy, () => {
    return {};
  });
